module.exports = ".print-label{\n  padding: 10px;\n  text-align: center;\n  border-style: dashed;\n  width: 250px;\n  height: 250px;\n  margin: 5px;\n}\n.print-page{\n  background-color: white;\n  height:5000px;\n\n}\n.form-buttons{\n  /*margin-top: 15px;*/\n  margin-bottom: 5px;\n  text-align: -webkit-center;\n}\n\n\n\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/table/print-qrcodes/print-qrcodes.component.css
// module id = ./src/app/table/print-qrcodes/print-qrcodes.component.css
// module chunks = main